import { API } from "../lib/api";

export const SITE = {
  name: "Yalı Yurt",
  fullName: "Samsun Özel Yalı Erkek Öğrenci Yurdu",
  shortLabel: "Erkek Öğrenci Yurdu",
  city: "Atakum / Samsun",
  phone: "0538 076 61 55",
  phoneHref: "tel:+905380766155",
  whatsapp: "905380766155",
  address: "Körfez Mah. Atatürk Bulvarı No:154",
  addressCity: "Atakum / Samsun",
  since: "2009",
  facebook: "https://www.facebook.com/profile.php?id=100070556723050",
  instagram: "https://www.instagram.com/yaliyurtsamsun/",
};

export const waLink = (msg) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg)}`;

const FILES_BASE = `${API}/files`;
export const LOGO_BLACK = `${FILES_BASE}/yaliyurt/uploads/bb525b85-568d-41cd-ae1f-e326e4d01a5b.png`;
export const LOGO_WHITE = `${FILES_BASE}/yaliyurt/uploads/95fc2206-0399-47f4-8c6a-d0761a59e31a.png`;
export const LOGO_ICON_WHITE = `${FILES_BASE}/yaliyurt/uploads/44182f63-f392-4d68-93ed-775fc9efe0e9.png`;
export const LOGO_TEXT_WHITE = `${FILES_BASE}/yaliyurt/uploads/a6127944-413e-4946-9a3a-1c8de18b6310.png`;
export const LOGO_FOOTER = `${FILES_BASE}/yaliyurt/uploads/0d6b76cf-6305-4697-b16c-5588f734f71f.png`;

export const WA_DEFAULT = waLink(
  "Merhaba, Yalı Yurt hakkında bilgi almak istiyorum."
);

export const NAV_LINKS = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/hakkimizda", label: "Yurt" },
  { to: "/nedenbiz", label: "Neden Biz" },
  { to: "/odalar", label: "Odalar" },
  { to: "/hizmetler", label: "İmkanlar" },
  { to: "/galeri", label: "Galeri" },
  { to: "/videolar", label: "Video" },
  { to: "/konum", label: "Konum" },
  { to: "/blog", label: "Blog" },
  { to: "/iletisim", label: "İletişim" },
];

const img = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: img("1460317442991-0ec209397118", 2000),
  intro: img("1522708323590-d24dbb6b0267"),
  photoBreak: img("1512917774080-9991f1c4c750", 2000),
  about: img("1523240795612-9a054b0db644"),
  videoPoster: img("1560448204-e02f11c3d0e2", 1800),
  study: img("1434030216411-0b793f4b4173"),
  library: img("1521587760476-6c12a4b040da"),
  food: img("1504674900247-0877df9cc836"),
  common: img("1522202176988-66273c2fd55f"),
  building: img("1545324418-cc1a3fa10c00"),
  roomExtra: img("1616594039964-ae9021a400a0"),
};

export const ROOMS = [
  {
    slug: "tek-kisilik",
    name: "Tek Kişilik Oda",
    capacity: "1 Kişi",
    short:
      "Tamamen size özel bir yaşam alanı. Derslerinize odaklanabileceğiniz sessiz, ferah ve konforlu bir oda.",
    detail:
      "Tek kişilik odalarımız, kendi alanına sahip olmak isteyen öğrenciler için tasarlandı. Odanızda size özel banyo ve WC, mini buzdolabı ve sınırsız kablosuz internet bulunur. 24 saat sıcak su ve merkezi ısınma ile yılın her günü ev konforunda bir yaşam sizi bekliyor. Birçok odamızda olduğu gibi balkonlu seçeneklerimiz de mevcuttur.",
    features: [
      "Özel Banyo & WC",
      "Mini Buzdolabı",
      "Sınırsız İnternet",
      "24 Saat Sıcak Su",
      "Oda Temizliği",
      "Balkonlu Seçenek",
    ],
    image: img("1595526114035-0d45ed16cfbf"),
  },
  {
    slug: "iki-kisilik",
    name: "İki Kişilik Oda",
    capacity: "2 Kişi",
    short:
      "Arkadaşlık ve mahremiyetin dengesi. Hem sosyal hem huzurlu, iki kişilik paylaşım alanı.",
    detail:
      "İki kişilik odalarımız, paylaşımlı yaşamı tercih eden öğrenciler için idealdir. Her odada özel banyo ve WC, mini buzdolabı ve sınırsız kablosuz internet standart olarak sunulur. Rahat, temiz ve sakin bir çalışma ortamı; 24 saat sıcak su ve merkezi ısınma ile desteklenir.",
    features: [
      "Özel Banyo & WC",
      "Mini Buzdolabı",
      "Sınırsız İnternet",
      "24 Saat Sıcak Su",
      "Oda Temizliği",
      "Balkonlu Seçenek",
    ],
    image: img("1567767292278-a4f21aa2d36e"),
  },
];

export const SERVICES = [
  {
    no: "01",
    title: "Güvenlik",
    desc: "24 saat güvenlik anlayışı; her kat kameralı sistemle kontrol altındadır. Polis karakolu hemen yanımızdadır.",
  },
  {
    no: "02",
    title: "Sıcak Su & Isınma",
    desc: "24 saat kesintisiz sıcak su ve merkezi ısınma sistemi ile yılın her günü konfor.",
  },
  {
    no: "03",
    title: "İnternet",
    desc: "Yurdun her noktasında sınırsız kablosuz internet; dersler ve sınav hazırlıkları için güçlü altyapı.",
  },
  {
    no: "04",
    title: "Yemek",
    desc: "Sağlıklı, taze ve lezzetli ev yemekleri. Kahvaltı hizmeti 07:00 – 09:30 arasında yemekhanemizde.",
  },
  {
    no: "05",
    title: "Temizlik",
    desc: "Düzenli oda temizliği ve hijyen standartları ile her zaman tertemiz bir yaşam alanı.",
  },
  {
    no: "06",
    title: "Çamaşır",
    desc: "Öğrencilerimiz için çamaşır yıkama hizmeti; günlük hayatın yükünü hafifletiyoruz.",
  },
  {
    no: "07",
    title: "Sosyal Alanlar",
    desc: "Ücretsiz spor alanları, bilardo masası, geniş manzaralı teras ve bahçeli oturma alanları.",
  },
  {
    no: "08",
    title: "Çalışma Ortamı",
    desc: "Rahat, temiz ve sakin çalışma ortamı; ders başarınız için ihtiyacınız olan huzur.",
  },
];

export const DISTANCES = [
  { place: "Toplu Taşıma", time: "1 dk", note: "Dolmuş ve otobüs durakları kapımızda" },
  { place: "Tramvay Durağı", time: "100 m", note: "Yürüme mesafesinde" },
  { place: "OMÜ Kampüsü", time: "1 km", note: "Üniversitenin hemen girişinde" },
  { place: "Tıp Fakültesi", time: "4 dk", note: "" },
  { place: "Siyasal Bilgiler", time: "5 dk", note: "" },
  { place: "Ziraat Fakültesi", time: "8 dk", note: "" },
  { place: "Diş Hekimliği", time: "8 dk", note: "" },
  { place: "Fen Edebiyat", time: "9 dk", note: "" },
  { place: "Mühendislik Fakültesi", time: "10 dk", note: "" },
];

export const GALLERY = [
  { src: img("1595526114035-0d45ed16cfbf", 1400), alt: "Tek kişilik oda", span: "large" },
  { src: img("1522708323590-d24dbb6b0267", 1200), alt: "Yaşam alanı", span: "tall" },
  { src: img("1504674900247-0877df9cc836", 1200), alt: "Ev yemekleri", span: "small" },
  { src: img("1434030216411-0b793f4b4173", 1200), alt: "Çalışma ortamı", span: "small" },
  { src: img("1567767292278-a4f21aa2d36e", 1400), alt: "İki kişilik oda", span: "wide" },
  { src: img("1521587760476-6c12a4b040da", 1200), alt: "Kütüphane ve etüt", span: "tall" },
  { src: img("1616594039964-ae9021a400a0", 1200), alt: "Oda detayı", span: "small" },
  { src: img("1512917774080-9991f1c4c750", 1400), alt: "Yurt binası", span: "wide" },
];

export const MARQUEE_ITEMS = [
  "Güvenli ve Konforlu",
  "Ev Yemekleri",
  "7/24 Güvenlik",
  "24 Saat Sıcak Su",
  "Sınırsız İnternet",
  "Üniversiteye 1 km",
  "Balkonlu Odalar",
  "Manzaralı Teras",
];
